var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import anyTrait from "../Decorators/anyTrait";
import objectTrait from "../Decorators/objectTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import { traitClass } from "../Trait";
import mixTraits from "../mixTraits";
import { GeoJsonTraits } from "./GeoJsonTraits";
import GetCapabilitiesTraits from "./GetCapabilitiesTraits";
import StyleTraits from "./StyleTraits";

// TODO: this is repeated in two files, WMS and WFS. In a global config somewhere?
export const SUPPORTED_CRS_4326 = ["EPSG:4326", "urn:ogc:def:crs:EPSG::4326", "urn:x-ogc:def:crs:EPSG:4326", "CRS:84", "EPSG:4283"];
export const SUPPORTED_CRS_3857 = ["EPSG:3857", "urn:ogc:def:crs:EPSG::3857", "urn:x-ogc:def:crs:EPSG:3857", "EPSG:900913", "urn:ogc:def:crs:EPSG::900913", "urn:x-ogc:def:crs:EPSG:900913"];
let WebFeatureServiceCatalogItemTraits = (_dec = traitClass({
  description: "Creates a single item in the catalog from url that points to a WFS service.\n  <strong>Note:</strong> <i>Must specify property <b>typeNames</b>.</i>",
  example: {
    type: "wfs",
    name: "wfs example",
    url: "https://warehouse.ausseabed.gov.au/geoserver/ows",
    typeNames: "ausseabed:AHO_Reference_Surface__Broome__2023_0_5m_L0_Coverage",
    id: "some unique id for wfs example"
  }
}), _dec2 = primitiveTrait({
  type: "string",
  name: "Type Name(s)",
  description: "The type name or names to display."
}), _dec3 = primitiveTrait({
  type: "number",
  name: "Max features",
  description: "Maximum number of features to display."
}), _dec4 = primitiveTrait({
  type: "string",
  name: "Srs Name",
  description: "Spatial Reference System to use. For WFS we prefer WGS 84 (".concat(SUPPORTED_CRS_4326.join(", "), "). With WFS requests it is best to use the urn identifier for the srsName, to enforce lat,long order in returned results.")
}), _dec5 = primitiveTrait({
  type: "string",
  name: "Output Format",
  description: "Output format to request for WFS requests. We prefer GeoJSON. We support gml3 and gml3.1.1 but only in EPSG:4326 projection or similar."
}), _dec6 = anyTrait({
  name: "Parameters",
  description: "Additional parameters to pass to the WFS Server when requesting features."
}), _dec7 = objectTrait({
  type: StyleTraits,
  name: "Style",
  description: "Styling rules that follow [simplestyle-spec](https://github.com/mapbox/simplestyle-spec)"
}), _dec(_class = (_class2 = class WebFeatureServiceCatalogItemTraits extends mixTraits(GeoJsonTraits, GetCapabilitiesTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "typeNames", _descriptor, this);
    _initializerDefineProperty(this, "maxFeatures", _descriptor2, this);
    _initializerDefineProperty(this, "srsName", _descriptor3, this);
    _initializerDefineProperty(this, "outputFormat", _descriptor4, this);
    _initializerDefineProperty(this, "parameters", _descriptor5, this);
    _initializerDefineProperty(this, "style", _descriptor6, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "typeNames", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "maxFeatures", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 1000;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "srsName", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "outputFormat", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "parameters", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "style", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return undefined;
  }
}), _class2)) || _class);
export { WebFeatureServiceCatalogItemTraits as default };